var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generate-dialog"},[_c('Card',{staticClass:"dialog-content"},[_c('div',{staticClass:"dialog-spinner"},[_c('Spin',{attrs:{"size":"large","fix":""}})],1),_c('div',{staticClass:"dialog-msg"},[_vm._v(_vm._s(_vm.msg))])]),_c('div',{staticClass:"reports-container"},[_c('Report',{attrs:{"id":"report"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }